import axios from 'axios';
const search = {
    search: document.getElementById('quickSearch'),
    wrap: document.getElementById('quickResults'),
    loader: document.getElementById('loader'),

    init() {
        if (this.search) {
            this.searchProd();

        }

    },
    searchProd() {
        let checking = false;
        if (checking) {
            clearTimeout(checking);
        }


        this.search.addEventListener('keyup', () => {
            if (!checking) {
                this.loader.classList.remove('d-none');
                if(this.search.value !== '') {
                    checking = setTimeout(() => {
                        axios.get(`https://all-in-season.neto.com.au/all/?rf=kw&kw=${this.search.value}`)
                            .then(res => {
                                let parser = new DOMParser();
                                return parser.parseFromString(res.data, 'text/html');
    
                            })
                            .then(res => {
                                let list = res.getElementById('quickList');                           
                                this.wrap.innerHTML = list ? list.outerHTML : '';
                                this.loader.classList.add('d-none');
                                checking = false;
                            })
    
    
                    }, 500);
                }else{
                    this.wrap.innerHTML =  '';
                    this.loader.classList.add('d-none');
                    checking = false;
                }
              
            }
        })
    },


}

export default search;